import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons"; 

/**
 * @param {Object} props
 * @param {string} props.message
 */
export default function NoAvailableQuotesBanner(props) {
    return (
        <div
            style={{
                background: "#F8ECFA33",
                border: "1px solid #D48EE3",
                borderRadius: 8,
                padding: 10,
                display: "flex",
                gap: 10,
                alignItems: "center",
                justifyContent: "center",
                margin: "20px 0",
                animation: "fadeIn 0.8s"
            }}
        >
            <InfoCircleOutlined style={{ color: "#B945D0" }} />
            <p
                style={{
                    color: "black",
                    fontSize: 12,
                    margin: 0
                }}
            > {props.message }</p>
        </div>
    )

}